import { render } from "./SenaraiRalat.vue?vue&type=template&id=7e95f4a2"
import script from "./SenaraiRalat.vue?vue&type=script&lang=js"
export * from "./SenaraiRalat.vue?vue&type=script&lang=js"

import "./SenaraiRalat.vue?vue&type=style&index=0&id=7e95f4a2&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__